/**
 * @Author: Li, Yu Jia
 * @Date: 2019-12-02 13:23:17
 * @Last Modified by: Li, Yu Jia
 * @Last Modified time: 2020-09-11 09:11:48
 * @Usage: imprintarea.actions.type
 */

import { createAction } from '@reduxjs/toolkit';

const ImprintAreaActionType = {
  IMPRINTAREAS_INIT: 'IMPRINTAREAS_INIT',
  IMPRINTAREASCOMBINED_INIT: 'IMPRINTAREASCOMBINED_INIT',
  TEXT_LAYOUT_INIT: 'TEXT_LAYOUT_INIT',
  LOGO_LAYOUT_INIT: 'LOGO_LAYOUT_INIT',
  TEXT_LAYOUT_SELECT_DEFAULT: 'TEXT_LAYOUT_SELECT_DEFAULT',
  LOGO_LAYOUT_SELECT_DEFAULT: 'LOGO_LAYOUT_SELECT_DEFAULT',
  IMPRINTAREASCOMBINED_SELECT: 'IMPRINTAREASCOMBINED_SELECT',
  IMPRINT_OPTION_TYPE_INIT: 'IMPRINT_OPTION_TYPE_INIT',
  IMPRINT_OPTION_TYPE_SELECT: 'IMPRINT_OPTION_TYPE_SELECT',
  LOGO_LAYOUT_SELECT: 'LOGO_LAYOUT_SELECT',
  TEXT_LAYOUT_SELECT: 'TEXT_LAYOUT_SELECT',
  IMPRINT_COLOR_INITIALIZE: 'IMPRINT_COLOR_INITIALIZE',
  IMPRINT_COLOR_UPDATE: 'IMPRINT_COLOR_UPDATE',
  CLEAR_IMPRINT_AREA_CONTENT: 'CLEAR_IMPRINT_AREA_CONTENT',
  IMPRINT_THUMBNAILS_INITIALIZE: 'IMPRINT_THUMBNAILS_INITIALIZE',
};

export const imprintAreasInit = createAction(ImprintAreaActionType.IMPRINTAREAS_INIT);
export const imprintAreasCombinedInit = createAction(ImprintAreaActionType.IMPRINTAREASCOMBINED_INIT);
export const textLayoutInit = createAction(ImprintAreaActionType.TEXT_LAYOUT_INIT);
export const logoLayoutInit = createAction(ImprintAreaActionType.LOGO_LAYOUT_INIT);
export const textLayoutSelectDefault = createAction(ImprintAreaActionType.TEXT_LAYOUT_SELECT_DEFAULT); //TODO:yjli.remove this action, only use for (screen)digital item
export const logoLayoutSelectDefault = createAction(ImprintAreaActionType.LOGO_LAYOUT_SELECT_DEFAULT); //TODO:yjli.remove this action, only use for (screen)digital item
export const logoLayoutSelect = createAction(ImprintAreaActionType.LOGO_LAYOUT_SELECT);
export const textLayoutSelect = createAction(ImprintAreaActionType.TEXT_LAYOUT_SELECT);
export const imprintAreasCombinedSelect = createAction(ImprintAreaActionType.IMPRINTAREASCOMBINED_SELECT);
export const imprintOptionTypeInit = createAction(ImprintAreaActionType.IMPRINT_OPTION_TYPE_INIT);
export const imprintOptionTypeSelect = createAction(ImprintAreaActionType.IMPRINT_OPTION_TYPE_SELECT);
export const imprintColorInitialize = createAction(ImprintAreaActionType.IMPRINT_COLOR_INITIALIZE);
export const imprintColorUpdate = createAction(ImprintAreaActionType.IMPRINT_COLOR_UPDATE);
export const clearImprintAreaContent = createAction(ImprintAreaActionType.CLEAR_IMPRINT_AREA_CONTENT);
export const imprintThumbnailInitialize = createAction(ImprintAreaActionType.IMPRINT_THUMBNAILS_INITIALIZE);
